module.exports = __webpack_public_path__ + "img/icon-editar.5cc2fc94.svg";